import { render, staticRenderFns } from "./kafpos-form-error.vue?vue&type=template&id=ec9f57c0&lang=pug"
import script from "./kafpos-form-error.vue?vue&type=script&setup=true&lang=js"
export * from "./kafpos-form-error.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports